import { fields, buildCartPayload } from './jfl-contour-rod-cart.js';

function initialize(root) {
  if (root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const form = root.querySelector('form');
  const variants = JSON.parse(root.querySelector('[data-variants]').textContent);
  const messages = JSON.parse(root.querySelector('[data-messages]').textContent);
  const groups = [...root.querySelectorAll('[data-field]')];
  const notes = root.querySelector('[data-notes]');
  const quantity = form.elements.quantity;
  const button = root.querySelector('[data-add-button]');
  const error = root.querySelector('[data-error]');
  let pending = false;
  const configuration = () => Object.fromEntries([
    ...groups.map(group => [group.dataset.field, group.querySelector('input:checked')?.value || '']),
    ['Customization notes', notes.value]
  ]);

  function update() {
    const config = configuration();
    const other = config['Thread wrap color'] === 'Other — confirmation required';
    notes.required = other;
    notes.setCustomValidity(other && !notes.value.trim() ? messages.notesError : '');
    root.querySelector('[data-notes-label]').textContent = other ? messages.notesRequired : messages.notesOptional;
    root.querySelector('[data-summary-values]').replaceChildren();
    groups.forEach(group => {
      const selected = group.querySelector('input:checked');
      const value = selected?.dataset.choiceLabel || messages.choose;
      group.querySelector('[data-selected-label]').textContent = value;
      const dt = document.createElement('dt');
      dt.textContent = group.querySelector('legend').textContent;
      const dd = document.createElement('dd');
      dd.textContent = value;
      root.querySelector('[data-summary-values]').append(dt, dd);
    });
    if (notes.value.trim()) {
      const dt = document.createElement('dt');
      dt.textContent = messages.notesOptional;
      const dd = document.createElement('dd');
      dd.textContent = notes.value.trim();
      root.querySelector('[data-summary-values]').append(dt, dd);
    }
    const selectedNative = variants.find(v => v.title === [config['Rod type'], config['Hardware finish'], config['Rear grip']].join(' / '));
    const rearGripPrices = variants.filter(v => v.title.split(' / ')[2] === config['Rear grip']);
    const uniformRearGripPrice = rearGripPrices.length > 0 && rearGripPrices.every(v => v.priceLabel === rearGripPrices[0].priceLabel);
    const displayedPrice = selectedNative?.priceLabel || (uniformRearGripPrice ? rearGripPrices[0].priceLabel : null);
    if (displayedPrice) root.querySelectorAll('[data-price]').forEach(el => el.textContent = displayedPrice);
    const unavailable = selectedNative?.available === false;
    button.disabled = pending || unavailable;
    button.textContent = pending ? messages.adding : unavailable ? messages.soldOut : messages.add;
    const variantInput = form.querySelector('[data-jfl-variant]');
    variantInput.disabled = true;
    quantity.removeAttribute('max');
    if (selectedNative?.inventory_management && selectedNative.inventory_policy === 'deny' && selectedNative.inventory_quantity != null) quantity.max = Math.max(0, selectedNative.inventory_quantity);
    try {
      const item = buildCartPayload(config, variants, Number(quantity.value)).items[0];
      variantInput.value = item.id;
      variantInput.disabled = false;
      fields.forEach(field => form.querySelector(`[data-property="${field}"]`).value = item.properties[field]);
    } catch {
      fields.forEach(field => form.querySelector(`[data-property="${field}"]`).value = '');
    }
  }

  form.addEventListener('invalid', event => {
    const group = event.target.closest('details');
    if (group) group.open = true;
  }, true);
  form.addEventListener('change', update);
  form.addEventListener('input', update);
  root.querySelector('[data-review]').addEventListener('click', () => {
    const missing = groups.find(group => !group.querySelector('input:checked'));
    if (missing) {
      missing.open = true;
      missing.scrollIntoView({behavior:'smooth', block:'center'});
      missing.querySelector('input').focus({preventScroll:true});
    } else if (!notes.checkValidity()) {
      notes.focus();
      notes.reportValidity();
    } else root.querySelector('[data-summary]').scrollIntoView({behavior:'smooth', block:'center'});
  });
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (pending) return;
    update();
    if (!form.reportValidity()) return;
    error.hidden = true;
    try {
      const payload = buildCartPayload(configuration(), variants, Number(quantity.value));
      pending = true;
      update();
      const response = await fetch(root.dataset.addUrl, {
        method:'POST', credentials:'same-origin',
        headers:{'Content-Type':'application/json', 'Accept':'application/json'},
        body:JSON.stringify(payload)
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || messages.error);
      window.location.assign(root.dataset.cartUrl);
    } catch (e) {
      error.textContent = e.message || messages.error;
      error.hidden = false;
      pending = false;
      update();
    }
  });
  update();
}

document.querySelectorAll('[data-jfl-contour-builder]').forEach(initialize);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-jfl-contour-builder]').forEach(initialize));

